import { color } from "@styles";
import Image from "next/image";
import { FC } from "react";
import styled from "styled-components";

interface GlobalRewardPaginationMobile {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const GlobalRewardPaginationMobile: FC<GlobalRewardPaginationMobile> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const pageNumbers = Array.from({ length: totalPages }, (_, page) => page + 1);

  return (
    <Container>
      <BackButton onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        <Image height={24} width={24} alt="Back button" src="/static/icons/pagination/Back.svg" />
      </BackButton>
      {pageNumbers.map((pageNumber) => {
        const isSelected = currentPage === pageNumber;
        return (
          <PaginationButton
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            disabled={isSelected}
            isSelected={isSelected}
          >
            {pageNumber}
          </PaginationButton>
        );
      })}
      <NextButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <Image height={24} width={24} alt="Next button" src="/static/icons/pagination/Next.svg" />
      </NextButton>
    </Container>
  );
};

export default GlobalRewardPaginationMobile;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 2rem;
`;

const NavigationButton = styled.button<{ disabled?: boolean }>`
  margin: 0 1rem;
  border: 0;
  background: 0;
  cursor: pointer;
`;

const BackButton = styled(NavigationButton)``;

const NextButton = styled(NavigationButton)`
  visibility: ${(p) => (p.disabled ? "hidden" : "visible")};
`;

const PaginationButton = styled.button<{ isSelected: boolean }>`
  margin: 0 0.5rem;
  cursor: pointer;
  border: 0;
  background: 0;
  color: ${(p) => (p.isSelected ? color.S3100 : color.S340)};
  font-size: 1rem;
`;
